import uploadImage from "@faire/web-api--source/api/image/upload/post";
/**
 * Cannot use web-api for this endpoint as it is a multi-part form
 */ export var uploadImageFile = function(image, onUploadProgress, formData) {
    var data = formData !== null && formData !== void 0 ? formData : new FormData();
    data.append("file", image);
    return uploadImage(data, {
        onUploadProgress: onUploadProgress
    });
};
